// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Platform Selection Modal Styles */
.platform-selection-modal {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.platform-selection-content {
  padding: 20px;
}

.platform-selection-title {
  font-weight: bold;
  margin-bottom: 16px;
}

.platform-selection-description {
  line-height: 1.6;
  color: #333;
}
`, "",{"version":3,"sources":["webpack://./src/pages/homeDashboard/components/Modals/PlatformSelectionModal/PlatformSelectionModal.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,4DAA4D;AAC9D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb","sourcesContent":["/* Platform Selection Modal Styles */\n.platform-selection-modal {\n  font-family: \"Segoe UI\", Tahoma, Geneva, Verdana, sans-serif;\n}\n\n.platform-selection-content {\n  padding: 20px;\n}\n\n.platform-selection-title {\n  font-weight: bold;\n  margin-bottom: 16px;\n}\n\n.platform-selection-description {\n  line-height: 1.6;\n  color: #333;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
